import { useCurrentUser } from "./Auth";
import { Redirect } from "./Redirect";
import { jsx as _jsx } from "react/jsx-runtime";
export function Redirector() { var auth = useCurrentUser(); switch (auth === null || auth === void 0 ? void 0 : auth.role) {
    case "mechanic": return /*#__PURE__*/ _jsx(Redirect, { to: "/mechanic-home" });
    case undefined: return null;
    default: return /*#__PURE__*/ _jsx(Redirect, { to: "/projects" });
} }
